import { Box, Button, Stack, TextField, Typography } from "@mui/material";
import { type SxProps, type Theme } from "@mui/material/styles";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import PageLayout from "../components/common/page-layout";
import { RequireAuth } from "../hooks/use-auth";

const styles = {
  form: { maxWidth: 560, mt: 2 },
} satisfies Record<string, SxProps<Theme>>;

/**
 * Entry point for the ingestion test-run debug pane. There is no list of runs
 * (the backend exposes no list query — a run is looked up strictly by id), so
 * this is a simple id entry that routes to the run's detail pane.
 */
const IngestionTestRunsPage = () => {
  const navigate = useNavigate();
  const [runId, setRunId] = useState("");
  const trimmed = runId.trim();

  return (
    <RequireAuth>
      <PageLayout
        subtitle="New document-extraction pipeline"
        title="Ingestion test runs"
      >
        <Typography gutterBottom variant="body2" color="text.secondary">
          Open the debug pane for an end-to-end test run by its id.
        </Typography>
        <Box
          component="form"
          sx={styles.form}
          onSubmit={(event) => {
            event.preventDefault();
            if (trimmed.length > 0) {
              navigate(`/ingestion-test-runs/${trimmed}`);
            }
          }}
        >
          <Stack direction="row" spacing={1} alignItems="center">
            <TextField
              fullWidth
              size="small"
              label="Run id"
              value={runId}
              onChange={(event) => {
                setRunId(event.target.value);
              }}
            />
            <Button
              type="submit"
              variant="contained"
              disabled={trimmed.length === 0}
            >
              Open
            </Button>
          </Stack>
        </Box>
      </PageLayout>
    </RequireAuth>
  );
};

export default IngestionTestRunsPage;
